<div class="student-assessment-details-list m-auto">
  <div class="bg-white rounded shadow-sm-darker">
    <div class="tab-btns-wrap d-flex">
      <button (click)="showpendingassessments()" class="tab-btn border-0" [ngClass]="{'tab-btn--active': pendingassignment}">
        <span class="mr-2">Pending</span>
        <span class="badge badge-warning badge-circle">{{pendingCount}}</span>
      </button>
      <button (click)="showsubmittedassessments()" class="tab-btn border-0" [ngClass]="{'tab-btn--active': submittedassignment}">
        <span class="mr-2">Submitted</span>
        <span class="badge badge-success badge-circle">{{submittedCount}}</span>
      </button>
    </div>
    <div class="p-4">
      <p *ngIf="(assessments.length== 0 || !assessments) && pendingassignment" class="font-italic">No Pending Assessments</p>
      <p *ngIf="(assessments.length== 0 || !assessments) && submittedassignment" class="font-italic">No Submitted Assessments</p>
      <ul *ngIf="assessments && assessments.length > 0" class="list-group list-group-flush">
        <li class="list-group-item px-0" *ngFor="let assessment of assessments">
          <app-dashboarduserassessmentdetail [assessment]="assessment"></app-dashboarduserassessmentdetail>
        </li>
      </ul>
    </div>
  </div>
</div>